module.exports = __webpack_public_path__ + "img/211.c1df15fe.png";